import { render, staticRenderFns } from "./TrainingQuestionsFormPage.vue?vue&type=template&id=63c0648f&"
import script from "./TrainingQuestionsFormPage.vue?vue&type=script&lang=js&"
export * from "./TrainingQuestionsFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports